import t from '@jetshop/intl';
import * as React from 'react';
import styled from 'react-emotion';

import { Next, Prev } from './Buttons';
import PageLinks from './PageLinks';

import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import qs from 'qs';
import { withRouter } from 'react-router';

export const PaginationWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 400px) {
    flex-direction: column;

    & > * {
      margin-bottom: 10px;
    }
  }
`;

const Pagination = ({
  location,
  prevPage,
  nextPage,
  currentPage,
  totalPages,
  isFirstPage,
  isLastPage,
  goToPage,
  hasPages
}) => {
  const { queryParam } = React.useContext(PaginationContext);
  const currentLocation = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const nextHref =
    location.pathname +
    qs.stringify(
      Object.assign(Object.assign({}, currentLocation), {
        [queryParam]: isLastPage ? currentPage : currentPage + 1
      }),
      { addQueryPrefix: true, encodeValuesOnly: true, skipNulls: true }
    );
  const prevHref =
    location.pathname +
    qs.stringify(
      Object.assign(Object.assign({}, currentLocation), {
        [queryParam]: isFirstPage ? currentPage : currentPage - 1
      }),
      { addQueryPrefix: true, encodeValuesOnly: true, skipNulls: true }
    );
  return hasPages ? (
    <PaginationWrapper>
      <Prev
        to={prevHref}
        onClick={prevPage}
        disabled={isFirstPage}
        aria-label="Previous"
      >
        {t('Back')}
      </Prev>
      <PageLinks
        totalPages={totalPages}
        currentPage={currentPage}
        goToPage={goToPage}
      />
      <Next
        to={nextHref}
        onClick={nextPage}
        disabled={isLastPage}
        aria-label="Next"
      >
        {t('Next')}
      </Next>
    </PaginationWrapper>
  ) : null;
};

export default withRouter(Pagination);
